import React from 'react'
import { LoadingIndicatorSize } from '../loading-indicator'
import { BaseButton }  from './base-button'
import type { ButtonProps } from './types'

const Button: React.FC<ButtonProps> = ({ ...props }) => {
  return <BaseButton loadingIndicatorSize={LoadingIndicatorSize.medium} {...props} />
}

export default Button
